
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-loan-against-property",
      function () {
        return require("private-next-pages/corporate-loan-against-property/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-loan-against-property"])
      });
    }
  